import styled from 'styled-components';

import { Label } from '@xing-com/label';
import { RadioButton } from '@xing-com/radio-button';
import { RadioButtonGroup } from '@xing-com/radio-button-group';
import {
  xdlColorSelected,
  xdlColorControlFillTertiary,
  xdlPaletteWhite,
} from '@xing-com/tokens';

const StyledRadioButtonGroup = styled(RadioButtonGroup)`
  justify-content: center;
  li {
    padding: 2px;
  }
`;

const HiddenRadioButton = styled(RadioButton)`
  opacity: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0;
  z-index: 1;

  &:focus + span {
    background-color: ${xdlColorSelected};
    color: white;
    border-color: ${xdlColorSelected};
  }
`;

const StyledCircle = styled.span<{ $checked: boolean }>`
  border-radius: 50%;
  border: 2px solid ${xdlColorControlFillTertiary};
  background-color: ${({ $checked }) =>
    $checked ? xdlColorSelected : xdlColorControlFillTertiary};
  color: ${({ $checked }) => ($checked ? xdlPaletteWhite : '#333')};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  aspect-ratio: 1;
  height: 44px;
`;

const StyledLabel = styled(Label)`
  display: inline-flex;
  align-items: center;
  position: relative;
  margin-right: 0px;
  cursor: pointer;
`;

export const Styled = {
  HiddenRadioButton,
  StyledCircle,
  StyledRadioButtonGroup,
  StyledLabel,
};
